export default __webpack_public_path__ + "static/media/battery_90.8ab5893b.svg";